/**
 * Polyfill for `Promise.withResolvers` (TC39, shipped in Safari/iOS only in
 * 17.4). pdfjs-dist@5 uses it in both the main bundle and the PDF worker, so
 * resume parsing crashes with "undefined is not a function" on iPhones running
 * iOS 17.0–17.3. Safe no-op where the API already exists. Works in any global
 * scope (window or worker) since it only touches the global `Promise`.
 */
type WithResolvers = <T>() => {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

const P = Promise as unknown as { withResolvers?: WithResolvers };

if (typeof P.withResolvers !== "function") {
  P.withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export {};
